/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabContentArea from 'features/userData/tab/TabContentArea';
import MapArea from 'features/userData/map/MapArea';
import useLayerManagement from 'features/userData/hooks/useLayerManagement';
import WorkspaceLayout from 'components/my_map/workspace/WorkspaceLayout';
import { MY_MAP_WORKSPACE_TABS } from 'components/my_map/workspace/tabs';

const UserDataPage = () => {
    const {
        layers,
        selectedLayerIndex,
        setSelectedLayerIndex,
        updateLayer,
        reorderLayers,
        removeLayer,
        fileInputRef,
        isUploadModalOpen,
        isDragActive,
        openUploadModal,
        closeUploadModal,
        handleFileUpload,
        handleClick,
        handleDrop,
        handleDragOver,
        handleDragLeave,
        handleDownload1,
        handleDownload2,
    } = useLayerManagement();

    const dataTab = 'layer';
    const [isAttributeTableExpanded, setIsAttributeTableExpanded] = useState(false);
    const navigate = useNavigate();

    const handleWorkspaceTabChange = (tabId) => {
        if (tabId === 'geocoder') {
            navigate('/my_map/geocoder');
        }
    };

    const sidebarContent = (
        <TabContentArea
            activeTab={dataTab}
            layers={layers}
            selectedLayerIndex={selectedLayerIndex}
            setSelectedLayerIndex={setSelectedLayerIndex}
            updateLayer={updateLayer}
            removeLayer={removeLayer}
            reorderLayers={reorderLayers}
            isTableExpanded={isAttributeTableExpanded}
            setIsAttributeTableExpanded={setIsAttributeTableExpanded}
            fileInputRef={fileInputRef}
            isUploadModalOpen={isUploadModalOpen}
            isDragActive={isDragActive}
            openUploadModal={openUploadModal}
            closeUploadModal={closeUploadModal}
            handleFileUpload={handleFileUpload}
            handleClick={handleClick}
            handleDrop={handleDrop}
            handleDragOver={handleDragOver}
            handleDragLeave={handleDragLeave}
            handleDownload1={handleDownload1}
            handleDownload2={handleDownload2}
        />
    );

    return (
        <WorkspaceLayout
            tabs={MY_MAP_WORKSPACE_TABS}
            activeTab="user-data"
            onTabChange={handleWorkspaceTabChange}
            sidebarContent={sidebarContent}
        >
            <MapArea
                layers={layers}
                selectedLayerIndex={selectedLayerIndex}
                attrGeojson={
                    selectedLayerIndex != null && layers[selectedLayerIndex]
                        ? layers[selectedLayerIndex].geojson
                        : null
                }
                isTableExpanded={isAttributeTableExpanded}
            />
        </WorkspaceLayout>
    );
};

export default UserDataPage;
